<div class='poam-component' style='height: 100%'>
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div>
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin: 10px 10px 10px 10px">{{project?.name}} - Gap Report</h2>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 6px;margin-bottom: 10px;align-items:center;">
      <button mat-raised-button
              style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
              class="button" [routerLink]="['/projects', 'project', projectId]">
        Back to project
      </button>
      <a mat-raised-button
              style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
              class="button" href="{{this.config.api + '/api/projects/project/' + projectId + '/poamreport?token=' + token}}">
        Download PDF
      </a>
    </div>
  </div>

  <p-table [value]="poamItems"
           #poamTable
           [rows]="100"
           [reorderableColumns]="true"
           [paginator]="true"
           [pageLinks]="3"
           sortField="currentYearSequence"
           sortOrder="descending"
           [rowsPerPageOptions]="[10, 20, 50, 100]"
           [resizableColumns]="true"
           [metaKeySelection]="false"
           exportFilename="POAM"
           (onColResize)="onColumnResize($event)"
           [columns]="cols">

    <ng-template pTemplate="caption">
      <div class="ui-helper-clearfix flex flex-row justify-content-end">
        <button type="button"
                pButton
                class="risksponge-button"
                icon="pi pi-file-excel"
                iconPos="left"
                mwlConfirmationPopover
                [popoverTitle]=this.constants.WARNING_CUI_TITLE
                [popoverMessage]=this.constants.WARNING_CUI_MESSAGE
                popoverClass="confirmation-popover-hide-popover-arrow"
                [hideCancelButton]="true"
                placement="left"
                appendToBody="true"
                (confirm)="poamTable.exportCSV()"
                confirmText={{this.constants.LBL_I_UNDERSTAND}}>
        </button>
      </div>
    </ng-template>
    <ng-template #warningCUI let-options="options">
      <div class='poam-component'>
        <div class="header">
          <h2 mat-dialog-title>Warning: CUI // SP-CTI</h2>
          <button mat-icon-button [mat-dialog-close]="false">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div mat-dialog-content>
          This document may contain Controlled Unclassified Information.
          Unauthorized disclosure may result in civil or criminal penalties.
          Handle in accordance with <a href="https://www.archives.gov/files/cui/documents/cui-overview-powerpoint.pdf">NARA CUI guidance</a>.
        </div>
        <div mat-dialog-actions [align]="'end'">
          <button mat-raised-button [mat-dialog-close]="false">No</button>
          <button mat-raised-button color="primary" [mat-dialog-close]="true">Yes</button>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
        <th *ngFor="let col of cols" [pSortableColumn]="col.field" pResizableColumn [ngStyle]="{'width': col.width || 'auto', 'display': col.display === false ? 'none' : 'table-cell'}">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th *ngFor="let col of cols" [ngSwitch]="col.field" [ngStyle]="{'display': col.display === false ? 'none' : 'table-cell'}">
          <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                 (input)="poamTable.filter($event.target['value'], col.field, 'contains')">
          <span *ngSwitchCase="'dueDate'"></span>
        </th>

      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr [pSelectableRow]="item">
        <td *ngFor="let col of cols" [ngSwitch]="col.field" style="white-space: normal;" [ngStyle]="{'display': col.display === false ? 'none' : 'table-cell'}">
          <span *ngSwitchDefault>{{item[col.field]}}</span>
          <div class="my-center-text" *ngSwitchCase="'currentYearSequence'">
            <input [(ngModel)]="item.currentYearSequence" (change)="updatePOAMId(item)" />
          </div>
          <div *ngSwitchCase="'assessmentNotes'">
            <ul style="padding-left: 2em;">
              <li *ngFor="let note of item.assessmentNotes">A{{note.assessmentNoteId}} - {{note.name}}</li>
            </ul>
          </div>
          <div class="my-center-text" *ngSwitchCase="'complianceAreaControlId'">
            <div style="white-space: pre-line;text-align: left;">{{item.complianceAreaControlId}}</div>
          </div>
        </td>
      </tr>
    </ng-template>



  </p-table>
</div>
